<template>
  <!-- TODO: Add a border top -->
  <v-footer padless class="footer">
    <v-card color="background" flat tile width="100%">
      <v-col cols="12" class="text-center">
        <span> © 2021 - Telemonial </span>
      </v-col>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  name: "global-footer",
};
</script>

<style>
.footer {
  border-top: 1px solid;
  border-color: var(--v-divider-base) !important;
}
.footer span {
  color: var(--v-text-lighten2) !important;
}
</style>
